import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <footer style={{ justifyContent: 'center' }}>
        <p>Created by Team KBRAT &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; &#169;Code Fellows 2021</p>
      </footer>
    );
  }
}

export default Footer;
